import { render } from "./LbrxListCustomers.vue?vue&type=template&id=b9d043fe&scoped=true"
import script from "./LbrxListCustomers.vue?vue&type=script&lang=js"
export * from "./LbrxListCustomers.vue?vue&type=script&lang=js"

import "./LbrxListCustomers.vue?vue&type=style&index=0&id=b9d043fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d043fe"]])

export default __exports__